import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getObjectListApi, getObjectListByPropertyApi, getObjectListByPropertyValueArrayApi } from "api/general";
import { GATE_USER, GENERAL, ANNOUNCEMENT, AGENDA_TEMPLATE } from "app/utils/constants/customConstant";




const initialState = {
    customYkUserList: [],
    announcements: [],
    announcementsLoading: false,
    announcementsSuccess: false,
    announcementsError: false,
    announcementsMessage: '',
    agendaTemplates: [],
    agendaTemplatesLoading: false,
    agendaTemplatesSuccess: false,
    agendaTemplatesError: false,
    agendaTemplatesMessage: ''
};

export const getGeneralCustomYKMailSmsListAPI = createAsyncThunk("getGeneralCustomYKMailSmsListAPI", async (thunkAPI) => {
    try {

        let list = await getObjectListByPropertyApi(GENERAL, "type", 1);
        let customuserList = [];
        if (list.length > 0) {
            let idUsers = list.map(u => u.value);
            customuserList = await getObjectListByPropertyValueArrayApi(GATE_USER, "id", idUsers)
        }
        return customuserList;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }

})

export const getAnnouncementsAPI = createAsyncThunk("getAnnouncementsAPI", async (thunkAPI) => {
    try {
        const response = await getObjectListApi(ANNOUNCEMENT);
        return response.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
})

export const getAgendaTemplatesAPI = createAsyncThunk("getAgendaTemplatesAPI", async (thunkAPI) => {
    try {
        const response = await getObjectListApi(AGENDA_TEMPLATE);
        return response.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
})

const general = createSlice({
    name: "general",
    initialState,
    reducers: {
        setGeneralCustomYKMailSmsList: (state, action) => {
            state.customYkUserList = action.payload;
        },
        getGeneralCustomYKMailSmsListFetchData: (state, action) => {
            state.customYkUserList = action.payload;
        },
        setAnnouncements: (state, action) => {
            state.announcements = action.payload;
        },
        clearAnnouncements: (state) => {
            state.announcements = [];
            state.announcementsLoading = false;
            state.announcementsSuccess = false;
            state.announcementsError = false;
            state.announcementsMessage = '';
        },
        setAgendaTemplates: (state, action) => {
            state.agendaTemplates = action.payload;
        },
        clearAgendaTemplates: (state) => {
            state.agendaTemplates = [];
            state.agendaTemplatesLoading = false;
            state.agendaTemplatesSuccess = false;
            state.agendaTemplatesError = false;
            state.agendaTemplatesMessage = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGeneralCustomYKMailSmsListAPI.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getGeneralCustomYKMailSmsListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.customYkUserList = action.payload;
            })
            .addCase(getGeneralCustomYKMailSmsListAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.authUser = null;
            })
            .addCase(getAnnouncementsAPI.pending, (state) => {
                state.announcementsLoading = true;
                state.announcementsError = false;
                state.announcementsMessage = '';
            })
            .addCase(getAnnouncementsAPI.fulfilled, (state, action) => {
                state.announcementsLoading = false;
                state.announcementsSuccess = true;
                state.announcements = action.payload;
            })
            .addCase(getAnnouncementsAPI.rejected, (state, action) => {
                state.announcementsLoading = false;
                state.announcementsError = true;
                state.announcementsMessage = action.payload;
            })
            .addCase(getAgendaTemplatesAPI.pending, (state) => {
                state.agendaTemplatesLoading = true;
                state.agendaTemplatesError = false;
                state.agendaTemplatesMessage = '';
            })
            .addCase(getAgendaTemplatesAPI.fulfilled, (state, action) => {
                state.agendaTemplatesLoading = false;
                state.agendaTemplatesSuccess = true;
                state.agendaTemplates = action.payload;
            })
            .addCase(getAgendaTemplatesAPI.rejected, (state, action) => {
                state.agendaTemplatesLoading = false;
                state.agendaTemplatesError = true;
                state.agendaTemplatesMessage = action.payload;
            })
    }
});

export const {
    setGeneralCustomYKMailSmsList,
    getGeneralCustomYKMailSmsListFetchData,
    setAnnouncements,
    clearAnnouncements,
    setAgendaTemplates,
    clearAgendaTemplates
} = general.actions;

export default general.reducer;